import React from "react";

export const ResendLink = () => {
  return (
    <svg
      width="62"
      height="56"
      viewBox="0 0 62 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.7904 25.2085L42.7011 30.1191V25.2085H37.7904ZM45.7511 13.0082H33.5508V18.8033H45.7511C50.9668 18.8033 55.2064 23.0429 55.2064 28.2586C55.2064 32.1321 52.8578 35.4872 49.5027 36.9208L53.7728 41.1909C58.1039 38.5068 61.0015 33.7182 61.0015 28.2586C61.0015 19.8403 54.1693 13.0082 45.7511 13.0082ZM0 4.68147L9.48574 14.1672C3.9346 16.4243 0 21.8839 0 28.2586C0 36.6768 6.83217 43.5089 15.2504 43.5089H27.4507V37.7138H15.2504C10.0347 37.7138 5.79514 33.4742 5.79514 28.2586C5.79514 23.4089 9.48574 19.4133 14.2134 18.8948L20.527 25.2085H18.3005V31.3086H26.6272L33.5508 38.2323V43.5089H38.8275L51.0583 55.7397L55.3589 51.4391L4.30061 0.380859L0 4.68147Z"
        fill="#605DAF"
      />
    </svg>
  );
};
